import { HtmlMarker } from 'azure-maps-control';
import citiesEurope from './citiesEurope.json';

export const AZURE_MAP_KEY = process.env.REACT_APP_AZURE_MAPS_KEY;
export const AZURE_MAP_CLIENT_ID = process.env.REACT_APP_AZURE_MAPS_CLIENT_ID;
export const AZURE_LOCATION_SEARCH_URI =
  'https://atlas.microsoft.com/search/address/reverse/json?api-version=1.0';
export const AZURE_TIMEZONE_SEARCH_URI =
  'https://atlas.microsoft.com/timezone/byCoordinates/json?api-version=1.0&options=all';
export const AZURE_ADDRESS_SEARCH_URI =
  'https://atlas.microsoft.com/search/address/json?api-version=1.0';

// Helsinki, Finland
export const DEFAULT_LAT = 60.16981;
export const DEFAULT_LON = 24.93813;

const headers = {
  'x-ms-client-id': AZURE_MAP_CLIENT_ID,
};

export const searchLocation = (lat, lng) => {
  const url = `${AZURE_LOCATION_SEARCH_URI}&query=${lat},${lng}&subscription-key=${AZURE_MAP_KEY}`;

  return fetch(url, { headers })
    .then(result => result.json())
    .then(location =>
      location.addresses.length > 0 ? location.addresses[0].address : null
    );
};

export const searchTimezone = (lat, lng) => {
  const url = `${AZURE_TIMEZONE_SEARCH_URI}&query=${lat},${lng}&subscription-key=${AZURE_MAP_KEY}`;

  return fetch(url, { headers })
    .then(result => result.json())
    .then(data => (data.TimeZones?.length > 0 ? data : null));
};

export const searchAddress = keywords => {
  const url = `${AZURE_ADDRESS_SEARCH_URI}&query=${keywords}&subscription-key=${AZURE_MAP_KEY}`;

  return fetch(url, { headers })
    .then(result => result.json())
    .then(response =>
      response.results.length > 0 ? response.results[0] : null
    );
};

export const findCityByBoundaries = ({
  northEast,
  southWest,
  topLeftPoint,
  btmRightPoint,
}) => {
  // Boundary parameter names are differs depending on the api
  const [northEastLat, northEastLng] = northEast
    ? northEast.split(',')
    : [topLeftPoint.lat, topLeftPoint.lon];
  const [southWestLat, southWestLng] = southWest
    ? southWest.split(',')
    : [btmRightPoint.lat, btmRightPoint.lon];

  return citiesEurope
    .filter(item => {
      if (
        parseFloat(item.lat) < parseFloat(northEastLat) + 0.02 &&
        parseFloat(item.lat) > parseFloat(southWestLat) - 0.02 &&
        parseFloat(item.lng) < parseFloat(northEastLng) + 0.02 &&
        parseFloat(item.lng) > parseFloat(southWestLng) - 0.02
      ) {
        return true;
      }

      return false;
    })
    .sort(
      (a, b) =>
        parseFloat(a.lat) < parseFloat(b.lat) &&
        parseFloat(a.lng) < parseFloat(b.lng)
    )?.[0];
};

export const drawHtmlMarkers = (markerProps, mapObject) => {
  mapObject.markers.clear();
  markerProps.forEach(markerData => {
    const marker = new HtmlMarker({
      color: markerData.color,
      text: markerData.text,
      draggable: markerData.draggable | false,
      htmlContent: markerData.htmlContent,
      position: markerData.position,
    });

    if (markerData.onDrag) {
      marker._addEventListener('dragend', async e => {
        const { lat, lng } = e.target.marker._lngLat;
        markerData.onDrag({ lat, lng });
      });
    }

    mapObject.markers.add(marker);
  });
};
